import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MobileStaffLayout from "../../components/mobile-staff/MobileStaffLayout";
import api from "../../api/client";
import { Users, Search, Phone, Mail, Plus, ChevronRight, Loader2 } from "lucide-react";

export default function StaffClients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/clients");
        setClients(data || []);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const filtered = clients.filter((c) => {
    if (!filter) return true;
    const q = filter.toLowerCase();
    const display = (c.raison_sociale || `${c.nom || ""} ${c.prenom || ""}`).toLowerCase();
    return display.includes(q) || (c.telephone || "").toLowerCase().includes(q) || (c.email || "").toLowerCase().includes(q);
  });

  return (
    <MobileStaffLayout title="Clients">
      <div className="px-5 pt-5 pb-3">
        <div className="text-[10px] uppercase tracking-[0.25em] text-[#E91E63] font-bold mb-1">// PORTEFEUILLE</div>
        <div className="flex items-end justify-between mb-2">
          <h2 className="font-display text-2xl font-extrabold text-[#0F1A3D]" style={{ fontFamily: "'Playfair Display', serif" }}>
            Clients <span className="text-base font-bold text-[#4B5775]">· {clients.length}</span>
          </h2>
        </div>

        <div className="relative">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#9CA3B5]" />
          <input value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Rechercher un client…" className="w-full h-10 pl-9 pr-3 text-sm rounded-md border border-[#E2E5F1] focus:outline-none focus:border-[#1E3A8A]" data-testid="ms-clients-search" />
        </div>
      </div>

      <div className="px-5 space-y-2">
        {loading ? (
          <div className="text-center py-8 text-[#4B5775]"><Loader2 className="w-5 h-5 animate-spin inline-block" /></div>
        ) : filtered.length === 0 ? (
          <div className="bg-white border border-dashed border-[#E2E5F1] rounded-xl p-8 text-center">
            <Users className="w-8 h-8 text-[#1E3A8A] mx-auto opacity-50 mb-2" />
            <div className="text-sm font-bold text-[#0F1A3D]">Aucun client</div>
          </div>
        ) : (
          filtered.map((c) => {
            const display = c.raison_sociale || `${c.civilite || ""} ${c.nom || ""} ${c.prenom || ""}`.trim();
            return (
              <Link
                key={c.id}
                to={`/clients/${c.id}`}
                className="bg-white border border-[#E2E5F1] rounded-xl p-3 flex items-center gap-3 active:bg-[#F8FAFC]"
                data-testid={`ms-client-${c.id}`}
              >
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#1E3A8A] to-[#E91E63] text-white flex items-center justify-center text-xs font-bold shrink-0">
                  {(c.raison_sociale || c.nom || "?").slice(0, 2).toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-sm text-[#0F1A3D] truncate">{display}</div>
                  <div className="text-[11px] text-[#4B5775] flex items-center gap-2 truncate">
                    {c.telephone && <span className="inline-flex items-center gap-0.5"><Phone className="w-3 h-3" /> {c.telephone}</span>}
                  </div>
                </div>
                <ChevronRight className="w-4 h-4 text-[#9CA3B5] shrink-0" />
              </Link>
            );
          })
        )}
      </div>
    </MobileStaffLayout>
  );
}
